/**
 * TanStack Query hooks for `enterprise-plan-unlock-csm-custom-slas-ssl-on-domain-custom-data-residency`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	enterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyQueryKeys,
	type CreateEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyBody,
	type ListEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyResponse,
	type EnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyRow,
} from "./api";

export function useEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyList(): UseQueryResult<ListEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyResponse, Error> {
	return useQuery({
		queryKey: enterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyQueryKeys.list(),
		queryFn: list,
	});
}

export function useEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyCreate(): UseMutationResult<EnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyRow, Error, CreateEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: enterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyQueryKeys.all });
		},
	});
}

export function useEnterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: enterprisePlanUnlockCsmCustomSlasSslOnDomainCustomDataResidencyQueryKeys.all });
		},
	});
}
